import { styles } from './wdk-dialog-body-default-styles.js';

export default class wdkDialogBodyDefault extends HTMLElement {
	async connectedCallback() {
		this.#createDom();
		this.#cleanupSlots();
	}

	#createDom() {
		const template = document.createElement('template');
		template.innerHTML = `
			${this.#sanitizeEvilHtml(styles)}
			<div class="dialogContent">
				<header><h2><slot name="header"></slot></h2></header>
				<article><slot></slot></article>
				<footer>
					<ul>
						<li><slot name="button_1"></slot></li>
						<li><slot name="button_2"></slot></li>
					</ul>
				</footer>
			</div>
		`;
		const clone = document.importNode(template.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}
	}

	#cleanupSlots() {
		window.setTimeout(() => {
			if (this.#hasSlot('header') === false) {
				this.shadowRoot.querySelector('header').remove();
			}

			if (this.#hasSlot('button_1') === false && this.#hasSlot('button_2') === false) {
				this.shadowRoot.querySelector('footer').remove();
			}

			if (this.#hasSlot('button_1') === false && this.#hasSlot('button_2') === true) {
				this.shadowRoot.querySelector('li:first-of-type').remove();
			}

			if (this.#hasSlot('button_1') === true && this.#hasSlot('button_2') === false) {
				this.shadowRoot.querySelector('li:last-of-type').remove();
			}
		});
	}

	#hasSlot(slotName) {
		const myVal = Array.from(this.shadowRoot.querySelectorAll('slot')).filter((element) => {
			return element.name === slotName && element.assignedElements().length !== 0;
		});
		return Boolean(myVal.length);
	}

	#sanitizeEvilHtml(string) {
		// Das muss nochmal ein richtiger sanatizer werden
		return String(string).replace(
			/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
			'',
		);
	}
}
